import {
    apiRequest,
    cutiList,
    cutiInactive,
    rekapCuti,
    rekap
} from "../../../../../../services/adapters/kepegawaian/cutiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", cutiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchRekap = async (query, cancelToken) => {
        return await apiRequest("get", rekap, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", cutiInactive, {
            body: query
        }, true)
    }
    fetchRekapCuti = async (query) => {
        return await apiRequest("get", rekapCuti, {
            body: query
        }, true)
    }

}

export default DataTableRepository